import { render } from "./UserCourse.vue?vue&type=template&id=bb4665e0"
import script from "./UserCourse.vue?vue&type=script&lang=js"
export * from "./UserCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__